import React from 'react';
import { Button } from '@material-ui/core';
import { MainContext } from '../../context';
import { SPOTIFY_LOGIN_URL, SPOTIFY_LOGIN_URL_TEST } from '../../constants';
import { useStyles } from './styles';
import { HomePageHeader } from './HomePageHeader';
import { GetStartedButton } from './GetStartedButton';

export const HomePage = () => {
  const classes = useStyles();
  const { accessToken, currentUser } = React.useContext(MainContext);

  return (
    <div className='centeredVertical'>
      <h1 className='title'>Explore new tunes!</h1>
      <p className='subtitle'>
        {currentUser !== null && `Welcome ${currentUser?.display_name}!`} Create and save a playlist that you'll love
      </p>
      <br />

      {accessToken === null && (
        <a href={SPOTIFY_LOGIN_URL_TEST}>
          <Button variant='contained' id='spotifyButton' size='large' className={classes.nextButton}>
            Log in with Spotify
            <img src={process.env.PUBLIC_URL + '/spotifylogo.png'} style={{ width: 20, marginLeft: 5 }} />
          </Button>
        </a>
      )}

      {accessToken !== null && <GetStartedButton />}
      <HomePageHeader />
    </div>
  );
};
